/**
 * Fictitious data for the Magileads Home page.
 * Replace with real API data later — the component props map 1:1 to these shapes.
 */

export const currentUser = {
  firstName: "Zineb",
  fullName: "Zineb Sidqui",
  handle: "#23",
  avatar: "", // put an image URL here to show a photo instead of initials
};

export const trial = {
  dateLabel: "06 Juillet 2026",
  daysLeft: 3,
};

// ----- Sidebar navigation -----------------------------------------------------
// icon values map to keys in components/common/AppIcon.jsx
export const navSections = [
  {
    id: "main",
    items: [
      { id: "dashboard", label: "Dashboard", icon: "dashboard" },
      { id: "magia", label: "MagIA", icon: "robot", badge: "Bêta" },
    ],
  },
  {
    id: "target",
    title: "Cibler",
    items: [
      {
        id: "create-list",
        label: "Créer une liste de prospects",
        icon: "list",
      },
      { id: "detected", label: "Prospects détectés", icon: "users" },
    ],
  },
  {
    id: "engage",
    title: "Engager",
    items: [
      { id: "templates", label: "Modèles de messages", icon: "template" },
      { id: "senders", label: "Comptes expéditeurs", icon: "at" },
      { id: "create-campaign", label: "Créer une campagne", icon: "megaphone" },
    ],
  },
  {
    id: "manage",
    title: "Gérer et analyser",
    items: [
      { id: "running", label: "Campagnes en cours", icon: "progress" },
      { id: "tracking", label: "Suivi des prospects", icon: "userCheck" },
      { id: "reports", label: "Rapports", icon: "report" },
    ],
  },
];

// ----- Quick action cards -----------------------------------------------------
export const quickActions = [
  {
    id: "new-campaign",
    label: "Nouvelle campagne",
    variant: "primary",
    icon: "megaphone",
  },
  {
    id: "new-list",
    label: "Créez une liste de prospects",
    variant: "default",
    kind: "channels",
  },
  {
    id: "ai-agent",
    label: "Configurez votre agent IA",
    variant: "default",
    kind: "avatars",
  },
  { id: "add-shortcut", label: "Ajouter un raccourci", variant: "dashed" },
];

// ----- KPI / stats cards ------------------------------------------------------
export const stats = [
  {
    id: "campaigns",
    icon: "megaphone",
    color: "primary",
    value: "0 campagne",
    note: "active",
    noteColor: "primary",
  },
  {
    id: "open",
    icon: "send",
    color: "orange",
    value: "0%",
    note: "Taux d'ouverture",
  },
  {
    id: "reply",
    icon: "reply",
    color: "teal",
    value: "0%",
    note: "Taux de réponse",
  },
  {
    id: "click",
    icon: "click",
    color: "blue",
    value: "0%",
    note: "Taux de clic",
  },
];

// ----- "Nécessite votre attention" -------------------------------------------
export const attentionItems = [
  {
    id: "linkedin",
    icon: "linkedin",
    color: "red",
    title: "Vous n'avez pas connecté votre compte Linkedin",
    description: "Vous ne pouvez pas envoyer de séquences Linkedin",
    action: "Connecter",
    actionColor: "red",
    critical: true,
  },
  {
    id: "email",
    icon: "mail",
    color: "red",
    title: "Vous n'avez pas connecté votre compte email",
    description: "Vous ne pouvez pas encore envoyer de séquences email",
    action: "Résoudre",
    actionColor: "red",
    critical: true,
  },
  {
    id: "list",
    icon: "list",
    color: "yellow",
    title: "Vous n'avez pas créé votre première liste",
    description: "Vous ne pouvez pas commencer à prospecter",
    action: "Créer",
    actionColor: "yellow",
  },
  {
    id: "templates",
    icon: "template",
    color: "yellow",
    title: "Vous n'avez pas créé vos modèles",
    description: "Vous ne pouvez pas commencer à prospecter",
    action: "Créer",
    actionColor: "yellow",
  },
  {
    id: "campaign",
    icon: "megaphone",
    color: "yellow",
    title: "Vous n'avez pas envoyé votre première campagne",
    description: "Vous ne pouvez pas commencer à prospecter",
    action: "Créer",
    actionColor: "yellow",
  },
];

// ----- "Activité en direct" ---------------------------------------------------
export const liveActivity = [
  {
    id: 1,
    icon: "mail",
    color: "yellow",
    title: "Marta Reyes a répondu à « Q2 SaaS Founders »",
    time: "Il y a 2 min",
  },
  {
    id: 2,
    icon: "linkedin",
    color: "blue",
    title: "Tom Okafor a accepté votre demande de connexion",
    time: "Il y a 14 min",
  },
  {
    id: 3,
    icon: "list",
    color: "primary",
    title: 'Votre liste "Startup founders" est prête',
    time: "Il y a 22 min",
  },
  {
    id: 4,
    icon: "calendar",
    color: "teal",
    title: "Vous avez un rappel à traiter",
    time: "Il y a 33 min",
  },
];

// ----- "Campagnes actives" ----------------------------------------------------
export const activeCampaigns = [
  {
    id: 1,
    name: "Q2 SaaS Founders — Outbound",
    status: "Active",
    channels: ["linkedin", "mail"],
    sent: 645,
    total: 982,
    rate: "9.4%",
    trend: "up",
    spark: [3, 3.6, 3.2, 4.4, 4.8, 5.6, 6.4, 7.2, 8.1, 9.4],
  },
  {
    id: 2,
    name: "Reactivation — Dormant Leads",
    status: "En pause",
    channels: ["linkedin", "mail", "reply"],
    sent: 367,
    total: 402,
    rate: "7.3%",
    trend: "up",
    spark: [2.1, 2.4, 2.9, 3.1, 3.9, 4.6, 5.2, 6.1, 6.8, 7.3],
  },
  {
    id: 3,
    name: "Series A → CRO Multichannel",
    status: "Active",
    channels: ["linkedin"],
    sent: 162,
    total: 356,
    rate: "3.2%",
    trend: "down",
    spark: [8.2, 8.4, 8.1, 7.4, 6.6, 6.9, 5.8, 4.7, 3.9, 3.2],
  },
  {
    id: 4,
    name: "Event Follow-up — SaaStr",
    status: "Active",
    channels: ["linkedin", "mail"],
    sent: 0,
    total: 298,
    rate: "-",
    trend: "flat",
    spark: [5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
  },
];
